module.exports = __webpack_public_path__ + "static/media/Bixby_white.81436091.png";